import React from 'react';
import { Icon } from '@core/js/components/common/Icon';
import style from './index.scss';

export default ({
    className = '',
    isVisible,
    onClick,
    ...props // data attributes
}) => (
    <Icon
        className={`${style.formFieldPasswordIcon} ${className}`}
        type="formFieldPasswordIcon"
        onClick={onClick}
        {...props}
    />
);
